import { faStar } from '@fortawesome/pro-regular-svg-icons'
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ToggleTargeted } from '../ExploreTable/useTargetHighschoolsExplore'

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
    height: 18,
  },
}))

interface TargetIconProps {
  hsId: string
  targeted: boolean
  toggleTargeted: ToggleTargeted
}

export default function TargetIcon({ hsId, targeted, toggleTargeted }: TargetIconProps) {
  const classes = useStyles()

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    void toggleTargeted([{ hsId, targeted: !targeted }])
  }

  return (
    <IconButton onClick={handleClick}>
      <FontAwesomeIcon
        icon={targeted ? faSolidStar : faStar}
        className={classes.icon}
      />
    </IconButton>
  )
}
